module.exports = __webpack_public_path__ + "09_hige_black.1643f26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/09_hige_black.png
// module id = 0tSy
// module chunks = 0